import { Box } from "@mui/material";
import ListItemCardCst from "@components/ListItemCardCst";
import { ServicesURL } from "@utils/utilsApi";
import { useParams } from "react-router-dom";
import { useFetchTable } from "@hooks/useFetchDataTable";

const STATIC_GROUPS_URL = ServicesURL["static-groups"];
const dateFormatter = new Intl.DateTimeFormat("it-IT", { dateStyle: "short" })
  .format;

export default function StaticGroupsPanel() {
  const { id: corporateId = "" } = useParams();
  const { dataTable } = useFetchTable(STATIC_GROUPS_URL, undefined, {
    pageIndex: "0",
    pageSize: "6",
    corporateId,
  });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {dataTable?.output?.map((group: any) => (
        <ListItemCardCst
          title={group.name}
          details={{ row1: `ID: ${group.id}` }}
          badges={[
            {
              label: `Creato il ${dateFormatter(new Date(group.creation_date))}`,
            },
          ]}
        />
      ))}
    </Box>
  );
}
